'use strict';
import React from 'react';
import HeaderAuthenticated from './headerAuthenticated';
import HeaderLogin from './headerLogin';
import HeaderLinks from './headerLinks';
import HeaderMinimal from './HeaderMinimal';
import classnames from 'classnames';
import flux from 'utils/flux';

var Header = React.createClass({
    displayName: 'Header',

    mixins: [],

    propTypes: {
        isAuthenticated: React.PropTypes.bool,
        hasAcceptedLatestTerms: React.PropTypes.bool,
        activeBasketId: React.PropTypes.string
    },

    render() {
        const {licensing} = flux.getStore('app').getState().config.toJS();
        const header = () => {
            if (this.props.isAuthenticated && this.props.hasAcceptedLatestTerms) {
                return <HeaderAuthenticated activeBasketId={this.props.activeBasketId}/>;
            } else if (this.props.isAuthenticated && !this.props.hasAcceptedLatestTerms) {
                return <HeaderMinimal/>;
            } else if (!licensing) {
                return <HeaderLinks/>;
            } else {
                return <HeaderLogin/>;
            }
        };
        return (
            <header className={classnames({
                'header--login': !this.props.isAuthenticated,
                'header--authenticated': (this.props.isAuthenticated || !this.props.hasAcceptedLatestTerms)
            })}>
                {header()}
            </header>
        );
    }
});

module.exports = Header;



// WEBPACK FOOTER //
// ./app/components/header/header.jsx